import Navigator from './navigator';

export const {
  push: masterPush,
  navigate: masterNavigate,
  setNavigator: setMasterNavigator,
} = new Navigator();
